import React from 'react'

import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'
import { formatCurrency } from '../../core/utils/NumberFormatting'

interface SpendingTabLabelProps {
  amount: number
  label: string
  variant?: 'mini' | 'full'
}

const SpendingTabLabel: React.FC<SpendingTabLabelProps> = ({ amount, label, variant = 'full' }) => {
  return (
    <Stack direction="column">
      <Text bold={true} sx={{ textTransform: 'none' }} variant="body1">
        {label}
      </Text>
      <Text variant="caption">{formatCurrency(amount, variant === 'mini' ? '0,0' : '0,0.00')}</Text>
    </Stack>
  )
}

export default SpendingTabLabel
